import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function ChevronDownIconSvg() {
  return (
    <svg
      width="53"
      height="32"
      viewBox="0 0 53 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_338_155637)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.4916 23.4965C48.3308 23.6561 48.1399 23.7827 47.9296 23.8691C47.7194 23.9555 47.494 24 47.2663 24C47.0387 24 46.8133 23.9555 46.6031 23.8691C46.3928 23.7827 46.2019 23.6561 46.0411 23.4965L26.4995 4.14029L6.95799 23.4965C6.79709 23.6558 6.60608 23.7822 6.39585 23.8685C6.18562 23.9547 5.9603 23.9991 5.73275 23.9991C5.5052 23.9991 5.27988 23.9547 5.06965 23.8685C4.85942 23.7822 4.66841 23.6558 4.50751 23.4965C4.34661 23.3371 4.21898 23.148 4.1319 22.9398C4.04482 22.7316 4 22.5084 4 22.2831C4 22.0577 4.04482 21.8346 4.1319 21.6264C4.21898 21.4182 4.34661 21.229 4.50751 21.0697L25.2743 0.503508C25.4351 0.343903 25.626 0.217276 25.8363 0.130875C26.0465 0.0444736 26.2719 0 26.4995 0C26.7272 0 26.9526 0.0444736 27.1628 0.130875C27.3731 0.217276 27.564 0.343903 27.7248 0.503508L48.4916 21.0697C48.6527 21.2289 48.7806 21.418 48.8678 21.6262C48.9551 21.8344 49 22.0577 49 22.2831C49 22.5085 48.9551 22.7317 48.8678 22.94C48.7806 23.1482 48.6527 23.3373 48.4916 23.4965Z"
          fill="#DFE4E5"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_338_155637"
          x="0"
          y="0"
          width="53"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_338_155637"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_338_155637"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default function ChevronDownIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={ChevronDownIconSvg} {...props} />
}
